var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _dec29, _dec30, _dec31, _dec32, _dec33, _dec34, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

/**
 * @copyright
 * Copyright(c) 2019 SICK AG
 */

/* eslint-disable jsdoc/require-returns */
import { Component, html, Prop, Watch } from '@sick-davinci/ce-decorators';
import { style } from './SegmentChart.style';
import { ColoredDataElement } from '../_utils/ColoredDataElement.js'; // should be imported first, so css variables from theme-base are available

import { toCssColorValue, resolveCssColor } from '../_utils/ColorTools.js';
import { ThemeService } from '../_utils/ThemeService.js'; // import theme, so color-variables can be resolved

import '@sick-davinci/theme-base/theme/light_theme.js';
import '@sick-davinci/theme-base/theme/light_ddg_theme.js';
import { CssTools } from '../_utils/CssTools.js';
import { IconRef } from '@sick-davinci/basic-elements';
import { SvgTools } from '../_utils/SvgTools.js';
import { NumberFormatter, defaultShorthandLabels } from '../_utils/NumberFormatter.js';
import { arc, pie, select } from 'd3';
/**
 * Displays pie-segments of defined sizes and colors along a circle.
 *
 * @example
 * ```html
 * <div style="width: 300px; height: 300px">
 *   <davinci-segment-chart values="[5, 10, 50, 80, 100]"></davinci-segment-chart>
 * </div>
 * ```
 */

export let SegmentChart = (_dec = Component({
  tag: 'davinci-segment-chart',
  style,
  dependencies: [IconRef]
}), _dec2 = Reflect.metadata("design:paramtypes", []), _dec3 = Prop(), _dec4 = Reflect.metadata("design:type", Object), _dec5 = Prop(), _dec6 = Reflect.metadata("design:type", Number), _dec7 = Prop(), _dec8 = Reflect.metadata("design:type", Object), _dec9 = Prop(), _dec10 = Reflect.metadata("design:type", String), _dec11 = Prop(), _dec12 = Reflect.metadata("design:type", Boolean), _dec13 = Watch('shorthandLabels'), _dec14 = Reflect.metadata("design:paramtypes", []), _dec15 = Prop(), _dec16 = Reflect.metadata("design:type", Object), _dec17 = Prop({
  reflectAsAttribute: false
}), _dec18 = Reflect.metadata("design:type", String), _dec19 = Prop(), _dec20 = Reflect.metadata("design:type", String), _dec21 = Prop(), _dec22 = Reflect.metadata("design:type", Object), _dec23 = Prop(), _dec24 = Reflect.metadata("design:type", Object), _dec25 = Prop({
  type: String
}), _dec26 = Reflect.metadata("design:type", String), _dec27 = Prop(), _dec28 = Reflect.metadata("design:type", Boolean), _dec29 = Prop(), _dec30 = Reflect.metadata("design:type", Number), _dec31 = Prop(), _dec32 = Reflect.metadata("design:type", Number), _dec33 = Watch('palette'), _dec34 = Reflect.metadata("design:paramtypes", []), _dec(_class = _dec2(_class = (_class2 = class SegmentChart extends ColoredDataElement {
  /**
   * Values to show as parts of the donut.
   * The large the value the larger the part (arc).
   * All values are normalized to the sum of all values.
   * Drawing starts at the top and continues in clock-wise-direction.
   * Each array element is colored accordings to the defined *palette* attribute.
   */

  /**
   * The maximum value to which all 'values' are normalized.
   * Must be > 0
   */

  /**
   * Defines the radial weight (size) of a value-entry compared to the other entries
   * Must be length of 'values' or 0
   */

  /**
   * The displayed unit string appended to each value
   */

  /**
   * use abbreviations for big numbers for value-labels (e.g. k=kilo=1000, m=milli=1/1000, etc.)
   *
   * @default defaultShorthandLabels
   */
  shorthandLabelsWatcher() {
    this._labelFormatter = new NumberFormatter(this.shorthandLabels);
  }
  /**
   * The colors to be used for the segments of the donut.
   * The first element denotes the color for the first segment, the second element denotes the color for the second segment so on.
   * Each entry of this array is either interpreted as an index referring to the selected palette, or a css-color-value designation (e.g. 'purple', '#ff00ff', 'rgba(255,255,128,0.5)')
   *
   * If there are more values than colors the array will be traversed from the beginning
   *
   * @default all colors of the current color-palette
   */


  get colors() {
    return this._getSeriesColors();
  }

  set colors(value) {
    this._setSeriesColors(value);

    this._computeSegmentColors();
  }
  /**
   * Centered svg-icon (see <davinci-icon-ref> for more details)
   *
   * @default ''
   */


  /**
   * Use values < 1 to reduce the scale. Set if space is needed for displaying label-text.
   * If not scale is 0, it is auto determined. This behavior might not be desired, since it can change by each new set label.
   */
  get scale() {
    return this._scale;
  }

  set scale(s) {
    if (s >= 0 && s <= 1) {
      this._scale = s;
    }
  }
  /**
   * compute colors if palette has changed
   */


  paletteWatcher() {
    this._computeSegmentColors();

    this.scheduleRender(true);
  }

  /**
   * ctor
   */
  constructor() {
    super();
    this._scale = 0;

    _initializerDefineProperty(this, "values", _descriptor, this);

    _initializerDefineProperty(this, "maxValue", _descriptor2, this);

    _initializerDefineProperty(this, "weights", _descriptor3, this);

    _initializerDefineProperty(this, "unit", _descriptor4, this);

    _initializerDefineProperty(this, "shorthandLabels", _descriptor5, this);

    _initializerDefineProperty(this, "symbol", _descriptor6, this);

    _initializerDefineProperty(this, "label", _descriptor7, this);

    _initializerDefineProperty(this, "legendLabels", _descriptor8, this);

    _initializerDefineProperty(this, "segmentLabels", _descriptor9, this);

    _initializerDefineProperty(this, "labelPos", _descriptor10, this);

    _initializerDefineProperty(this, "invertCenterColor", _descriptor11, this);

    _initializerDefineProperty(this, "gap", _descriptor12, this);

    this._labelFormatter = NumberFormatter.CREATE_DEFAULT();
    this.palette = 'state';

    this._computeSegmentColors();
  }
  /**
   * See base class
   */


  componentConnected() {
    super.componentConnected();
    ThemeService.GET_INSTANCE().addListener(() => this.paletteWatcher());
  }
  /**
   * See base class
   */


  render() {
    var _this$legendLabels;

    if (((_this$legendLabels = this.legendLabels) === null || _this$legendLabels === void 0 ? void 0 : _this$legendLabels.length) > 0) {
      return html`
      <davinci-legend placement="N" small-font compact symbol-size="${CssTools.REM2PIXEL(.7)}" symbols='["box"]'
        .labels=${this.legendLabels} .palette=${this.palette} .colors=${this.colors} .maxItems=${this.legendLabels.length}>
        ${this._createSVG()}
      </davinci-legend>`;
    } else {
      return html`${this._createSVG()}`;
    }
  }

  componentDidRender() {
    this._scaleSVG();
  }

  _scaleSVG() {
    // scale the svg so it fits either a given scale or the entire-space (auto)
    const svg = this.shadowRoot.querySelector('svg');

    if (this._scale === 0) {
      // auto-scale
      const w = svg.viewBox.baseVal.width;
      const bb = SvgTools.SVG_BOX(svg, style); // this._showBBox(bb);

      if (bb.width > w) {
        const w1 = -bb.x; // left edge <-> center

        const w2 = bb.width - w1; // right edge <-> center

        svg.firstElementChild.setAttribute('transform', `scale(${w / 2 / Math.max(w1, w2)})`);
      }
    } else {
      // fixed scale
      svg.firstElementChild.setAttribute('transform', `scale(${this._scale})`);
    }
  }
  /**
   * Show bounding box for debugging purposes
   */


  _showBBox(bb) {
    const r = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
    r.setAttribute('x', bb.x.toString());
    r.setAttribute('y', bb.y.toString());
    r.setAttribute('width', bb.width.toString());
    r.setAttribute('height', bb.height.toString());
    r.setAttribute('stroke', 'red');
    r.setAttribute('fill', 'none');
    this.shadowRoot.querySelector('svg').firstElementChild.appendChild(r);
  }
  /**
   * creates the element
   *
   * @returns the element
   */


  _createSVG() {
    const size = CssTools.REM2PIXEL(17);
    const radius = size / 2;
    const innerRadius = 0.36 * radius;
    let maxValue = this.maxValue;

    if (Number.isNaN(maxValue) || maxValue === undefined) {
      maxValue = 0;
    }

    maxValue = Math.max(maxValue, this.values.reduce((prev, cur) => Math.max(prev, cur), 0)); // create data from the properties, so it can be used with d3

    const data = this.values.map((v, i) => {
      var _this$weights$i, _this$weights, _this$segmentLabels;

      return {
        val: v,
        color: this._segmentColors[i % this._segmentColors.length],
        weight: (_this$weights$i = (_this$weights = this.weights) === null || _this$weights === void 0 ? void 0 : _this$weights[i]) !== null && _this$weights$i !== void 0 ? _this$weights$i : 1,
        label: ((_this$segmentLabels = this.segmentLabels) === null || _this$segmentLabels === void 0 ? void 0 : _this$segmentLabels[i]) || ''
      };
    });
    const gap = 1 - this.gap;
    const padRad = 100; // * create start, stop radians *

    const p = pie().value(d => d.weight).startAngle(-gap * Math.PI).sort(null) // if not null, the default sorter is used: based on weight
    .endAngle(gap * Math.PI).padAngle(0.05); // * create arcs (foreground, background, padding)
    // value arc

    const va = arc().innerRadius(innerRadius).outerRadius(d => (radius - innerRadius) * (d.data.val / maxValue) + innerRadius).padRadius(padRad); // background arc

    const ba = arc().innerRadius(innerRadius).outerRadius(() => radius).padRadius(padRad); // padding arc

    const padDif = maxValue / 50;
    const pa = arc().innerRadius(d => (radius - innerRadius) * (d.data.val / maxValue) + innerRadius).outerRadius(d => (radius - innerRadius) * ((d.data.val + padDif) / maxValue) + innerRadius); // * create the svg container and it's sub-elements *

    const parent = document.createElementNS('http://www.w3.org/2000/svg', 'svg'); // svg's must be created this way and not with createElement!

    const svg = select(parent).attr('viewBox', `${-radius} ${-radius} ${size} ${size}`).append('g'); // create central label

    svg.append('text').text(this.label).attr('text-anchor', 'middle').attr('font-weight', 'semibold').attr('font-size', CssTools.REM2PIXEL(.875)).attr('transform', `translate(0 ${this.labelPos === 'bottom' ? radius + CssTools.REM2PIXEL(2) : innerRadius + CssTools.REM2PIXEL(.75)})`);
    svg.selectAll('.backgroundArc').data(p(data)).enter().append('path').attr('fill', () => resolveCssColor('var(--davinci-color-background-3)')).attr('class', 'backgroundArc').attr('d', ba);
    svg.selectAll('.solidArc').data(p(data)).enter().append('path').attr('fill', d => d.data.color).attr('class', 'solidArc').attr('d', va);
    svg.selectAll('.padArc').data(p(data)).enter().append('path').attr('fill', () => resolveCssColor('var(--davinci-color-background)')).attr('class', 'padArc').attr('d', pa);
    const arcLabelPos = arc().innerRadius(radius).outerRadius(radius * 1.15); // make sure the text does not overwrite the chart itself: go from left to right if on the right side of the chart and vice versa

    const getTextAnchor = xPos => {
      if (xPos < -10) {
        return 'end';
      } else if (xPos > 10) {
        return 'start';
      } else {
        return 'mid';
      }
    }; // append labels for each arc


    svg.append('g').attr('font-size', CssTools.REM2PIXEL(.75)).attr('text-anchor', 'middle').selectAll('text').data(p(data)).join('text').attr('transform', d => `translate(${arcLabelPos.centroid(d)})`).call(text => text.append('tspan').attr('alignment-baseline', 'central').attr('font-weight', 'regular').attr('text-anchor', d => getTextAnchor(arcLabelPos.centroid(d)[0])).attr('stroke', d => d.data.color).attr('fill', d => d.data.color).text(d => {
      let label = this._labelFormatter.format(d.data.val) + this.unit;

      if (d.data.label) {
        const x = arcLabelPos.centroid(d)[0];

        if (x < 0) {
          // set label before or after the value
          label = d.data.label + ' ' + label;
        } else {
          label = label + ' ' + d.data.label;
        }
      }

      return label;
    })); // append the central icon and its background

    svg.append('circle').attr('r', innerRadius - CssTools.REM2PIXEL(.25 * 2)).attr('fill', resolveCssColor(this.invertCenterColor ? 'var(--davinci-color-text)' : 'var(--davinci-color-background-3)'));

    if (this.symbol) {
      const s = SvgTools.REPLACE_FILL_COLOR(this.symbol, resolveCssColor(this.invertCenterColor ? 'var(--davinci-color-background-3)' : 'var(--davinci-color-text-on-background)'));
      const img = ['data:', '<svg', '%3C'].some(v => s.startsWith(v)) ? SvgTools.EMBED_SVG(s) : s;
      svg.append('image').attr('x', -innerRadius * .7).attr('y', -innerRadius * .7).attr('width', innerRadius * 1.4).attr('height', innerRadius * 1.4).attr('href', img);
    }

    return parent;
  }
  /**
   * Computes the segment colors from the css styles of the segment-style elements.
   */


  _computeSegmentColors() {
    this._segmentColors = this.colors.map(color => toCssColorValue(color, this.palette));
  }

}, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "values", [_dec3, _dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [0];
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "maxValue", [_dec5, _dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 100;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "weights", [_dec7, _dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "unit", [_dec9, _dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '%';
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "shorthandLabels", [_dec11, _dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return defaultShorthandLabels;
  }
}), _applyDecoratedDescriptor(_class2.prototype, "shorthandLabelsWatcher", [_dec13, _dec14], Object.getOwnPropertyDescriptor(_class2.prototype, "shorthandLabelsWatcher"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "colors", [_dec15, _dec16], Object.getOwnPropertyDescriptor(_class2.prototype, "colors"), _class2.prototype), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "symbol", [_dec17, _dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "label", [_dec19, _dec20], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "legendLabels", [_dec21, _dec22], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "segmentLabels", [_dec23, _dec24], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, "labelPos", [_dec25, _dec26], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 'center';
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, "invertCenterColor", [_dec27, _dec28], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class2.prototype, "gap", [_dec29, _dec30], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return .25;
  }
}), _applyDecoratedDescriptor(_class2.prototype, "scale", [_dec31, _dec32], Object.getOwnPropertyDescriptor(_class2.prototype, "scale"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "paletteWatcher", [_dec33, _dec34], Object.getOwnPropertyDescriptor(_class2.prototype, "paletteWatcher"), _class2.prototype)), _class2)) || _class) || _class);
